  import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
  import { provideRouter ,withHashLocation } from '@angular/router';

  import { routes } from './app.routes';
  import { DatePipe } from '@angular/common';
  import { MessageService } from './services/PrintService/print.service';
  import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
  import { UserService } from './services/user/user.service';
  import { provideHttpClient, withInterceptors } from '@angular/common/http';
  import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
  import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
  import { provideNativeDateAdapter } from '@angular/material/core';
  import { provideToastr } from 'ngx-toastr';
import { jwttokenInterceptor } from './interceptor/jwttoken.interceptor';
import { AuthTokenService } from './services/auth-token/auth-token.service';
import { environment } from '../environments/environment';


const config: SocketIoConfig = { url: `${environment.ApiHost.host}:${environment.ApiHost.WebPort}`, options: {} };  
  export const appConfig: ApplicationConfig = {
    providers: [
        provideNgxWebstorage(
          withNgxWebstorageConfig({ separator: ':', caseSensitive: false }),
          withLocalStorage(),
          withSessionStorage()
      ),
      provideZoneChangeDetection({ eventCoalescing: true }), 
      provideRouter(routes, withHashLocation()),
      DatePipe,
      MessageService,
      UserService,
      AuthTokenService,
      provideHttpClient(
        withInterceptors([
          jwttokenInterceptor
        ])
      ),
      importProvidersFrom(SocketIoModule.forRoot(config)),
      importProvidersFrom(BrowserAnimationsModule),
      provideNativeDateAdapter(),
      provideToastr(),
    ]
  };
